export const NON_ASSIGNED = 'None assigned';
